import { AudioMetadata } from "../types";
import { calculateWaveform as calculateWaveformFn } from "@lib/audio/calculateWaveform";
import { reportError } from "@lib/utils/reportError";

// Known error source: Firefox cannot decode .aif/.aiff files, which causes
// decodeAudioData to throw an EncodingError with "unknown content type".
export const getAudioMetadata = async (data: File | ArrayBuffer, audioContext: AudioContext, { calculateWaveform = false }: { calculateWaveform?: boolean } = {}): Promise<AudioMetadata> => {
  try {
    const arrayBuffer = data instanceof File ? await data.arrayBuffer() : data;

    const buffer = await audioContext.decodeAudioData(arrayBuffer);
    const waveform = calculateWaveform ? calculateWaveformFn(buffer) : null;

    return {
      duration: buffer.duration,
      sampleRate: buffer.sampleRate,
      numberOfChannels: buffer.numberOfChannels,
      waveform
    };
  } catch (e) {
    const fileName = data instanceof File ? data.name : undefined;
    const fileType = data instanceof File ? data.type : undefined;
    const error = new Error(
      `Failed to decode audio data${fileName ? ` for "${fileName}"` : ""}${fileType ? ` (type: ${fileType})` : ""}`,
      { cause: e }
    );
    reportError(error);
    throw error;
  }
};

export const secondsToTimestamp = (s: number): string => {
  // Guard against NaN, undefined, null, Infinity, or negative values
  const safeSeconds = !Number.isFinite(s) || s < 0 ? 0 : s;

  const minutes = Math.floor(safeSeconds / 60);
  const seconds = Math.floor(safeSeconds % 60);
  // const milliseconds = Math.floor((s % 1) * 1000);

  const padded = (num: number, length: number) => {
    return (new Array(1 + length).join("0") + num.toString()).slice(-length);
  };

  return `${minutes}:${padded(seconds, 2)}`;
};
